import Vue from "vue";
import {$t} from "@/i18n";
import {fieldTransformation, getGroupFieldValue, getSidebarFieldComponent,} from "./field_params_specifics";
import {getCustomFieldsByRelatedType} from "../../composables/use-custom-fields";


export const relatedTypeEnum = {
    CLIENT: "client",
    PROJECT: "project",
    SUPPLIER: "supplier",
}
const fieldTypesWithoutTitle = ["contacts", "members", "notes", "reports", "emails", "billing_notes", "cp_menu_links"]
const panelIcons = {
    contacts: {icon: 'Pen', small: true, tooltip: $t("Edit contacts")},
    members: {icon: 'plus', tooltip: $t("Add member")},
    notes: {icon: 'plus', tooltip: $t("Add note")},
    billing_notes: {icon: 'plus', tooltip: $t("Add note")},
    documents: {icon: 'FolderOpen', tooltip: $t("Open")}
}
const excludedDataColumnsSettings = {
    client: ["client.client_initials", "client.color", "client.address_city", "client.address_zip"],
    project: ["project.color"],
    default: []
}

const virtualizedFields = [
    {
        group_name: $t('Reports'),
        group_key: "reports",
        type: "reports",
        related_type: "reports",
        name: "reports",
        sub_type: null,
        is_visible: true,
        sort_order: 1,
    },
    {
        group_name: $t('Billing notes'),
        group_key: "billing_notes",
        type: "billing_notes",
        related_type: "billing_notes",
        name: "billing_notes",
        sub_type: "invoice",
        is_visible: true,
        sort_order: 2,
    },
    {
        group_name: $t('Pinned notes'),
        group_key: "notes",
        type: "notes",
        related_type: "notes",
        name: "notes",
        sub_type: null,
        is_visible: true,
        sort_order: 3,
    },
    {
        group_name: $t('Members'),
        group_key: "members",
        type: "members",
        related_type: "members",
        name: "members",
        sub_type: null,
        is_visible: true,
        sort_order: 1_000_000
    },
]

export const getSidebarGroupedCustomFields = (accountId, relatedType, relatedObject, subType) => {
    let objectCustomFields = relatedObject.fields ? Vue.clone_object(relatedObject.fields) : {}
    let customFields = getCustomFieldsByRelatedType(accountId, [relatedType]);
    if (!customFields.length) return []

    const RelatedVirtualizedFields = getVirtualizedFields(subType)
    customFields = customFields.concat(RelatedVirtualizedFields)

    customFields.forEach(field => {
        let isTableField = field.data_column !== `${relatedType}.fields`;
        if (isTableField) {
            objectCustomFields[field.name] = relatedObject[field.name];
        }
        fieldTransformation(field, relatedObject);
    });
    return preparedPanels(customFields, objectCustomFields, relatedType, relatedObject)
}

const preparedPanels = (customFields, objectCustomFields, relatedType, relatedObject) => {
    const excludedDataColumns = getExcludedDataColumns(relatedObject, relatedType)
    let sortedCustomFields = Array.sort_by(customFields, "sort_order")

    let groupMapper = new Map();
    sortedCustomFields.forEach(x => groupMapper.set(x.group_name, x.group_key));

    let panels = []
    for (const [groupName, groupKey] of groupMapper.entries()) {
        let groupFields = customFields.filter(field => {
            const fieldGroupName = field.group_name == null ? "" : field.group_name
            const isSameGroup = String.str_equal(fieldGroupName, groupName, true)
            const isNotExcluded = excludedDataColumns.indexOf(field.data_column) === -1
            return isSameGroup && isNotExcluded
        })

        const panelIconKey = getPanelIconKey(groupKey, groupFields)

        let resultFields = groupFields.map(field => {
            return getSidebarField(field, objectCustomFields, relatedType, relatedObject)
        })
        resultFields = resultFields.filter(field => !(Array.isArray(field.value) && !field.value.length || !field.value))

        let sortedFields = resultFields.sort((a, b) => {
            if (a.field.sort_order < b.field.sort_order) return -1
            if (a.field.sort_order > b.field.sort_order) return 1
            return 0
        })
        if (sortedFields.length || groupKey === "notes") {
            panels.push({
                groupName: groupName,
                groupKey: groupKey,
                panelIcon: panelIcons[panelIconKey],
                fields: sortedFields
            })
        }
    }
    return panels
}

const getPanelIconKey = (groupKey, fields) => {
    for (const field of fields) {
        if (field.type === "contacts") {
            return "contacts"
        }
    }
    return groupKey
}

const getVirtualizedFields = (subType) => {
    return virtualizedFields.filter(virtualField => {
        return virtualField.sub_type === null || virtualField.sub_type === subType
    })
}

const getSidebarField = (field, objectCustomFields, relatedType, relatedObject) => {
    const isFieldTitle = !fieldTypesWithoutTitle.includes(field.type)
    const currentValue = objectCustomFields[field.name]
    const fieldValueBasedOnRules = getGroupFieldValue(field, relatedObject, relatedType)
    const fieldValue = fieldValueBasedOnRules !== null ? fieldValueBasedOnRules : currentValue
    return {
        name: field.name,
        field: field,
        value: fieldValue,
        component: getSidebarFieldComponent(field),
        showFieldTitle: isFieldTitle,
        isVisible: field.is_visible,
    }
}

const getExcludedDataColumns = (relatedObject, relatedType) => {
    const relatedDataColumns = excludedDataColumnsSettings[relatedType] || []
    const defaultDataColumns = excludedDataColumnsSettings["default"] || []
    let dataColumns = defaultDataColumns.concat(relatedDataColumns)

    if (relatedObject.is_account) {
        dataColumns.push("client.contacts")
    }

    return dataColumns
}
